import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import AddVideoComponent from "../../components/AdminPortal/Videos/AddVideo";
export default function AddVideo() {
  useEffect(() => {
    document.title = "Add Video - LWS Learning Portal";
  }, []);

  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">Add New Video</h4>
          <AddVideoComponent />
        </div>
      </section>
    </>
  );
}
